/*
 * 戒导航 · 博客数据统计与排序（jiedh/blog-stats）
 * =============================================================================
 * 博客列表排序控件：`[排序图标 创建时间 ▾] [方向图标]`
 *
 * 交互与视觉完全对齐「下载中心」的排序控件（packages/downloads 的 jd-sort-btn /
 * jd-sortdir-btn），只是选择器前缀换成 jb-，避免样式互相影响：
 *   · 维度下拉：Dropdown（单选，选中项前置 check 图标），选完自动收起；
 *   · 方向按钮：独立方形按钮，正序 `fa-sort-amount-up` / 倒序 `fa-sort-amount-down`；
 *   · 任意变更 → 写模块级 state + localStorage → 回调 onchange 让页面刷新列表到第 1 页。
 *
 * 为什么不自带列表刷新逻辑：
 *   本控件被注入到 fof/blog 的 BlogOverview 页面里，页面持有 BlogListState；
 *   由注入方（js/src/forum/index.tsx）传 onchange 回调，控件只负责「改排序 + 通知」，
 *   组件间不产生对 vendor 内部结构的额外依赖。
 *
 * 无障碍：Dropdown 用 accessibleToggleLabel；方向按钮同时给 title 与 aria-label。
 */

import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import { getSort, setSort } from '../sortState';
/** 五个可排序维度（顺序即下拉菜单顺序：时间类在前，计数类在后） */
const OPTIONS = [{
  key: 'createdAt',
  labelKey: 'sort_created'
}, {
  key: 'lastPostedAt',
  labelKey: 'sort_updated'
}, {
  key: 'commentCount',
  labelKey: 'sort_comments'
}, {
  key: 'viewCount',
  labelKey: 'sort_views'
}, {
  key: 'likeCount',
  labelKey: 'sort_likes'
}];
export default class BlogSortControl extends Component {
  /** 语言包取值：jiedh-blog-stats.forum.* */
  t(key) {
    return extractText(app.translator.trans(`jiedh-blog-stats.forum.${key}`));
  }

  /**
   * 选择排序维度。
   * 重复选择当前维度视为无操作（避免把用户已经调好的方向重置回默认）；
   * 切换维度时默认降序（时间越新 / 计数越大越靠前，符合直觉）。
   */
  pick(key) {
    const sort = getSort();
    if (sort.key === key) return;
    setSort({
      key,
      dir: 'desc'
    });
    this.emit();
  }

  /** 切换正序 / 倒序 */
  toggleDir() {
    const sort = getSort();
    setSort({
      key: sort.key,
      dir: sort.dir === 'asc' ? 'desc' : 'asc'
    });
    this.emit();
  }
  emit() {
    m.redraw();
    this.attrs.onchange?.(getSort());
  }
  view() {
    const sort = getSort();
    const active = OPTIONS.find(opt => opt.key === sort.key) ?? OPTIONS[0];
    return m("div", {
      className: "jb-sort"
    }, m(Dropdown, {
      buttonClassName: "Button jb-sort-btn",
      menuClassName: "Dropdown-menu jb-sort-menu",
      icon: "fas fa-sort-amount-down",
      label: this.t(active.labelKey),
      accessibleToggleLabel: this.t('sort_label')
    }, OPTIONS.map(opt => m(Button, {
      type: "button",
      className: "Dropdown-item"
      // 选中态用 check / empty 图标标记（与下载中心同一个做法，核心 Button 不消费 active）
      ,
      icon: opt.key === sort.key ? 'fas fa-check' : 'fas fa-empty',
      onclick: () => this.pick(opt.key)
    }, this.t(opt.labelKey)))), m("button", {
      type: "button",
      className: "jb-sortdir-btn",
      onclick: () => this.toggleDir(),
      title: this.t(sort.dir === 'asc' ? 'sort_asc' : 'sort_desc'),
      "aria-label": this.t('sort_direction')
    }, m(Icon, {
      name: sort.dir === 'asc' ? 'fas fa-sort-amount-up' : 'fas fa-sort-amount-down'
    })));
  }
}
flarum.reg.add('jiedh-blog-stats', 'forum/components/BlogSortControl', BlogSortControl);